import React from 'react';
import PropTypes from 'prop-types';
import { ButtonBoxWrapper, MoreInfo, SessionBoxWrapper } from './style';
import { CTA, HtmlRaw, Icon, Text } from '../../../atoms';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { ModalQuizEventId } from '../../../atoms/Modals/ModalQuizEvent';

const QuizBox = ({
  mediaIsPhone,
  session = {},
  modalOpen,
  quizSessionStart,
}) => {
  const { quiz_data: data } = session;

  return (
    <SessionBoxWrapper>
      <div>
        <div className="d-flex g-0">
          <Text type="h2" mb={16} className="section-title">
            Quiz "{data?.title}"
          </Text>
          {data?.completion === 'completed' && (
            <Text type="b3" mb={16} className="completed">
              Attività completata <Icon type="check-circle" size={20} />
            </Text>
          )}
        </div>
        <Text type="b3" mb={32}>
          <HtmlRaw html={data?.description} />
        </Text>
        <MoreInfo>
          <div>
            <Text type="h3" mb={8}>
              Percentuale di superamento
            </Text>
            <Text type="b3" mb={16} className="d-flex">
              {data?.min_perc_to_pass || 0}%
            </Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Durata
            </Text>
            <Text type="b3" mb={16}>
              {data?.duration} min
              <Icon type="clock-stopwatch" clickable={false} />
            </Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Numero massimo di tentativi
            </Text>
            <Text type="b3" mb={16}>
              {session?.session_quiz_tentatives}
            </Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Numero di tentativi rimanenti
            </Text>
            <Text type="b3" mb={16}>
              {data?.remaining_tentatives}
            </Text>
          </div>
        </MoreInfo>
      </div>
      <ButtonBoxWrapper>
        <Text type="h3" mb={16}>
          Accesso limitato ai partecipanti dell’evento
        </Text>
        {session?.session_quiz_visibility ? (
          <Text type="b3" mb={23}>
            Clicca su “Inizia” per svolgere il quiz
          </Text>
        ) : (
          <Text type="b3" mb={23}>
            Il pulsante “Inizia” si attiverà subito dopo la fine dell’evento
          </Text>
        )}
        <CTA
          disabled={
            !session?.session_quiz_visibility ||
            data?.remaining_tentatives <= 0 ||
            data?.completion === 'completed'
          }
          btnText="Inizia"
          onClick={() => {
            quizSessionStart(session?.session_id);
            modalOpen(ModalQuizEventId, {
              quiz: session?.quiz_data,
              session_id: session?.session_id,
            });
          }}
        />
      </ButtonBoxWrapper>
    </SessionBoxWrapper>
  );
};

QuizBox.propTypes = {
  mediaIsPhone: PropTypes.bool,
  session: PropTypes.object,
  modalOpen: PropTypes.func,
  quizSessionStart: PropTypes.func,
};

export default withMediaQueries(QuizBox);
